<template>
  <div class="interact—detail">
    <div class="interact-detail-header">
      <div class="title">往来历史</div>
    </div>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:1vh" class="interact-detail-tab">
        <el-tab-pane label="商机" name="clueList">
          <ClueList :clientName="clientName" :refreshId="refreshId" />
        </el-tab-pane>
        <el-tab-pane label="合同" name="contractList">
          <ContractList :clientName="clientName" :refreshId="refreshId" />
        </el-tab-pane>
        <el-tab-pane label="订单" name="projectList">
          <ProjectList :clientName="clientName" :refreshId="refreshId" />
        </el-tab-pane>
        <el-tab-pane label="结算" name="settlementList">
          <SettlementList :clientName="clientName" :refreshId="refreshId" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import ClueList from './ClueList.vue';
  import ContractList from './ContractList.vue';
  import ProjectList from './ProjectList.vue';
  import SettlementList from './SettlementList.vue'

  export default {
    name: "InteractDetail",
    props: {
      clientName: {
        type: String,
        required: true
      },
      clientId: {
        required: true
      }
    },
    components:{
      ClueList,
      ContractList,
      ProjectList,
      SettlementList
    },
    data(){
      return {
        activeName: 'projectList',
        refreshId: 0
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event)
      },

      refresh() {
        this.refreshId += 1
      }

    }
  };
</script>

<style lang="scss">
  .interact—detail {
    width: 100%;
    min-height: 300px;
    padding: 30px;
    box-shadow: 0 0px 10px 6px #f5f5f5;
    margin-bottom: 20px;
  }

  .interact-detail-header{
    display: flex;
    justify-content:space-between;
  }

  .title{
    font-weight: bold;
    font-size:18px
  }

  .interact-detail-tab {
    .el-tabs__item {
      min-width: 50px!important;
    }
  }

  .singleTable {
    height: 100%!important;
  }

  #dltableclient-clue-table {
    height: 540px!important;
  }

  #dltableclient-contract-table {
    height: 540px!important;
  }

  #dltableclient-project-table {
    height: 540px!important;
  }

  #dltableclient-settlement-table {
    height: 540px!important;
  }

</style>